import styled from 'styled-components';

const FieldWrapper = styled.div`
  padding: 0 0 1rem 0;
  width: 100%;
  clear: both;
`;

export default FieldWrapper;
